import { useState, useEffect } from "react";
import { useRouter } from "next/router";

import { alertService } from "src/services";
import { AlertObj } from "src/helpers";

const Alert = () => {
  const router = useRouter();
  const [alert, setAlert] = useState<AlertObj | null>(null);

  useEffect(() => {
    const subscription = alertService.alert.subscribe((alert) =>
      setAlert(alert),
    );
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    alertService.clear();
  }, [router]);

  useEffect(() => {
    if (alert) {
      const timer = setTimeout(() => {
        setAlert(null);
        alertService.clear();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  if (!alert) return null;

  // Tailwind color mapping based on alert type
  const styles: Record<string, { bg: string; text: string }> = {
    success: { bg: "bg-green-600", text: "text-white" },
    error: { bg: "bg-red-600", text: "text-white" },
    warning: { bg: "bg-yellow-400", text: "text-black" },
    info: { bg: "bg-blue-600", text: "text-white" },
  };

  const { bg, text } = styles[alert.type] || styles.info;

  return (
    <>
      <div className="fixed inset-0 z-[10040] pointer-events-none"></div>

      <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[10050] w-auto max-w-sm px-2">
        <div
          className={`flex items-center justify-between gap-3 rounded-lg shadow-md ${bg} ${text} text-sm px-3 py-2`}
        >
          <span className="leading-snug">{alert.message}</span>
          <button
            className={`hover:opacity-80 text-lg leading-none ${text}`}
            onClick={() => setAlert(null)}
          >
            &times;
          </button>
        </div>
      </div>
    </>
  );
};

export { Alert };
